var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fl-app",attrs:{"id":"app"}},[(_vm.isShowLayout)?_c(_vm.layout,{tag:"component",scopedSlots:_vm._u([{key:"router",fn:function(){return [_c('router-view')]},proxy:true}],null,false,1147609800)}):_vm._e(),_c('ui-portal-target',{attrs:{"name":"modals"}}),_c('fl-global-modals'),_c('fl-layout-loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }